import type { $Fetch } from 'ofetch';
import type { OutroConteudoGateway } from '@/application/port/out/OutroConteudoGateway';
import type { ListOutrosConteudosParams, OutroConteudo, UpsertOutroConteudoCommand } from '@/domain/model/OutroConteudo';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** Gateway HTTP de Outro Conteúdo — BE `/api/v1/outros-conteudos` (JSON). */
export class HttpOutroConteudoGateway implements OutroConteudoGateway {
  private readonly path = '/api/v1/outros-conteudos';
  constructor(private readonly client: $Fetch) {}

  async list(p: ListOutrosConteudosParams): Promise<OutroConteudo[]> {
    const params: Record<string, string> = {};
    if (p.disciplineId) params['disciplineId'] = p.disciplineId;
    const res = await this.client<ApiResponse<OutroConteudo[]>>(this.path, { method: 'GET', params });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertOutroConteudoCommand): Promise<OutroConteudo> {
    const res = await this.client<ApiResponse<OutroConteudo>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertOutroConteudoCommand): Promise<OutroConteudo> {
    const res = await this.client<ApiResponse<OutroConteudo>>(`${this.path}/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: cmd,
    });
    assertApiSuccess(res);
    return res.data;
  }

  async arquivar(id: string): Promise<void> {
    await this.client<void>(`${this.path}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
